import React from 'react';
import IntroSection from '../../component/introSection';
import { ResponsiveFlexDirection } from '../../component/responsive/responsivePaddingWrapper';
import { useMobile } from '../../hook/usePlatform';
import CompanyGreetings from './component/companyGreetings';
import CompanyPhoto from './component/companyPhoto';
import { lineColor } from '../../util/colors';

const IntroduceCompany : React.FC = () => {
  const isMobile = useMobile();
  const border = isMobile ? '' : `solid 1px ${lineColor}`;

  return (
    <div
      id="company_introduce"
    >
      <IntroSection
        title="[회사 소개]"
        content="특별한 인연을 위한 최상의 서비스, 시럽 인연과 함께 하세요"
      />
      <div
        style={{
          borderTop: border,
          position: 'relative',
        }}
      >
        <ResponsiveFlexDirection>
          <CompanyGreetings />
          {!isMobile ? (
            <div
              style={{
                position: 'absolute',

                left: '50%',
                height: '100%',
                width: '1px',
                backgroundColor: lineColor,
              }}
            />
          ) : null}
          <CompanyPhoto />

        </ResponsiveFlexDirection>
      </div>

    </div>
  );
};

export default IntroduceCompany;
